import React, { useCallback, useEffect, useState } from 'react';
import { ATMDropdown, ATMLoader } from 'shared-it-appmod-ui';
import { ToastSuccess } from 'src/components/atoms/toaster/toaster.component';
import FileManager from 'src/components/molecules/file-manager/file-manager.component';
import { useFileContext } from 'src/contexts/file.context';
import { actionTypes } from 'src/ducks/file.duck';
import Lang from 'src/libraries/language';
import { IFile } from 'src/models/file.model';
import { getFileStatus } from 'src/selectors/file.selector';

type IProps = {
  requestId: number;
  total: number;
};

const FlightRequestListUpload: React.FC<IProps> = ({ requestId, total }) => {
  const { state, actions } = useFileContext();
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(total);
  }, [total, setCount]);

  const handleClick = useCallback(
    (callback) => {
      actions.listByRequestIdGET(requestId);
      callback();
    },
    [actions, requestId]
  );

  const handleAdd = useCallback(
    async (file: IFile) => {
      const result = await actions.addPOST({
        ...file,
        requestId,
      });

      if (result.payload) {
        ToastSuccess(Lang.MSG_FILE_UPLOAD_SUCESS);
        setCount((value) => value + 1);
      }
    },
    [actions, setCount, requestId]
  );

  const handleDelete = useCallback(
    async (file: IFile) => {
      if (file.uploadId) {
        const result = await actions.dataDELETE(file.uploadId);

        if (result.payload) {
          ToastSuccess(Lang.MSG_FILE_DELETE_SUCESS);
          setCount((value) => value - 1);
        }
      }
    },
    [actions, setCount]
  );

  const status = getFileStatus(state, actionTypes.FILE_LIST_FETCH);

  if (!state.list) {
    return <ATMLoader active />;
  }

  return (
    <FileManager
      title={Lang.formatString(
        Lang.TTL_TICKET_FILE_DOCUMENT,
        requestId
      ).toString()}
      files={state.list}
      onSuccess={handleAdd}
      onDelete={handleDelete}
      loading={status.fetching}
      trigger={(callback) => (
        <ATMDropdown.Item
          content={Lang.formatString(Lang.LBL_UPLOAD_VIEW_FILES, count)}
          onClick={() => handleClick(callback)}
          icon="paperclip"
        />
      )}
    />
  );
};

export default FlightRequestListUpload;
